import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import TestimonialsFeedCarousel from 'src/app/organisms/Homepage/TestimonialsFeedCarousel/TestimonialsFeedCarousel';

const TestimonialsFeed = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-7xl', 'spacing-4xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
  >
    <TestimonialsFeedCarousel />
  </SectionLayout>
);

export default TestimonialsFeed;
